import React from "react";

const Status = () => {
  return <div>Status</div>;
};

export default Status;
